import {
  Avatar,
  Badge,
  Button,
  Drawer,
  DrawerProps,
  Flex,
  Form,
  FormInstance,
  Input,
  message,
  Space
} from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { forwardRef, Ref, useImperativeHandle, useState } from 'react'
import { HiMiniNoSymbol } from 'react-icons/hi2'
import { attemptUpdateSong, EditSongDTO, Song } from '../../../utils/redux/songsSlice'
import { listenerMiddleware, useAppDispatch } from '../../../utils/redux/store'

interface Props extends DrawerProps {
  subTitle?: string
  // bodyStyle?: DrawerStyles['body']
}

export interface EditSongDrawerMethods {
  open: (song: Song) => void
  close: () => void
}

const EditSongDrawer = forwardRef(
  (
    { title, subTitle, height, ...drawerProps }: Props,
    ref: Ref<EditSongDrawerMethods>,
  ) => {
    useImperativeHandle(
      ref,
      (): EditSongDrawerMethods => ({
        open: (song) => {
          setSong(song)
          editSongForm.setFieldsValue(song)
        },
        close: () => setSong(undefined),
      }),
    )

    const [song, setSong] = useState<Song>()
    const [editSongForm] = Form.useForm<EditSongDTO>()

    const isSongEditing = useAttemptListener({
      listenerMiddleware: listenerMiddleware,

      attempt: attemptUpdateSong,
      onFulfilled: () => {
        message.success('Successfully updated!')
        setSong(undefined)
      },
    })

    return (
      <Drawer
        placement="right"
        title="Edit song"
        height={height ?? 'auto'}
        closable={false}
        onClose={() => setSong(undefined)}
        extra={
          <Space>
            <Button onClick={() => setSong(undefined)}>Cancel</Button>
            <Button
              onClick={() => editSongForm.submit()}
              type="primary"
              loading={isSongEditing}
            >
              Submit
            </Button>
          </Space>
        }
        open={!!song}
        {...drawerProps}
      >
        {song && <EditSong editSongForm={editSongForm} song={song} />}
      </Drawer>
    )
  },
)

interface EditSongProps {
  editSongForm: FormInstance<EditSongDTO>
  song: Song
}
function EditSong({ editSongForm, song }: EditSongProps) {
  const dispatch = useAppDispatch()

  function onFinish(values: EditSongDTO) {
    dispatch(
      attemptUpdateSong({
        ...values,
        _id: song._id,
        file: song.file,
      }),
    )
  }

  return (
    <>
      <Flex justify="center" align="center" style={{ marginBottom: '3em' }}>
        <Badge
          // count={
          //   <Button shape="circle">
          //     <ImgCrop rotationSlider showGrid cropShape="round">
          //       <Upload
          //         accept="image/jpeg, image/png, image/jpg"
          //         showUploadList={false}
          //         multiple={false}
          //       >
          //         <FaPencil />
          //       </Upload>
          //     </ImgCrop>
          //   </Button>
          // }
          offset={[0, 150]}
        >
          <Avatar
            size={150}
            shape="square"
            icon={<HiMiniNoSymbol />}
            src={song.imageUrl}
          />
        </Badge>
      </Flex>
      <Form form={editSongForm} onFinish={onFinish} layout="vertical">
        <Form.Item name="title" required label="Title">
          <Input placeholder="Title" />
        </Form.Item>
        <Form.Item name="artist" required label="Artist">
          <Input placeholder="Artist" />
        </Form.Item>
      </Form>
    </>
  )
}

EditSongDrawer.displayName = 'EditSongDrawer'
export default EditSongDrawer
